import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import GHSubGroup from "@/components/GHSubGroup";
import { loadImageEnd } from "@/utils/images";
import { isItemVisible as checkItemVisible } from "@/utils/rhinoVersion";
import { mapState } from 'vuex';
export default {
  name: "GHGroupVector",
  components: {
    GHSubGroup /* SubGroup01 */
  },
  computed: {
    ...mapState({
      current_rhino_version: "current_rhino_version",
      highlightedIconId: state => state.highlightedIconId // Get the highlighted icon ID from Vuex.
    }),
    visibleGroups() {
      return this.subCategory.groups.filter(group => group.some(item => this.isItemVisible(item)));
    },
    hasVisibleIcons() {
      return this.visibleGroups.length > 0;
    }
  },
  methods: {
    isItemVisible(item) {
      return checkItemVisible(item, this.current_rhino_version);
    },
    collectAllIcons() {
      let allIcons = [];
      this.subCategory.groups.forEach(group => {
        group.forEach(item => {
          if (this.isItemVisible(item)) {
            allIcons.push(item.icon);
          }
        });
      });
      // 没有可见图标时无需等待加载，直接结束 loading，避免遮罩一直转圈
      this.isLoading = allIcons.length > 0;
      loadImageEnd(allIcons, () => {
        this.isLoading = false;
      });
    },
    sendCompNameInUrl(name_in_url, id) {
      this.$emit('clickComponent', name_in_url, id);
    }
  },
  watch: {
    // 首次渲染
    subCategory: {
      immediate: true,
      handler() {
        this.collectAllIcons();
      }
    },
    // 切换 Rhino 版本后可见图标集合会变化，需要重新预加载，
    // 否则 isLoading 会停在上一个版本的加载结果上
    current_rhino_version() {
      this.collectAllIcons();
    }
  },
  props: {
    subCategory: Object,
    rows: Number
  },
  data() {
    return {
      isLoading: true
    };
  }
};